import { Navigate, useLocation } from "react-router";
import { migrateLegacyParams, type LegacyParamRule } from "@/hooks/useLegacySearchParams";

/**
 * ESKİ ADRESİN YENİ YERİNE YÖNLENMESİ — sorgusu ve çapası İLE (6 Ekim 2026).
 *
 * Düz bir `<Navigate>` adresin YOLUNU taşıyordu, sorgusunu atıyordu. İki ayrı yerde ölçüldü:
 * - organizasyon şemasının «Çalışanlar» düğmesinin `/hr/employments?organizationUnitId=…`
 *   bağlantısı birim filtresini kaybediyordu; yönlenmiş ekran SÜZGEÇSİZ açılıyor ve bunu hiçbir
 *   şey söylemiyordu — kişi bütün şirketi o birim sanıyordu (ik-personel);
 * - onay kutusundaki «kaydı aç» bağlantısı (`/hr/leave-requests?record=…`) İK'yı izin talepleri
 *   listesine götürüyor ama talebi açmıyordu (ik-izin).
 * Eski adresin bütün değeri taşıdığı sorgudaydı ve yönlendirme tam da onu atıyordu.
 *
 * Anahtarlar olduğu gibi taşınır; `rules` yalnız ADI DEĞİŞMİŞ bir anahtarı yenisine çevirir
 * (`organizationUnitId` → `unit`). Kural dili `useLegacySearchParams`'ınki, kod da onun — iki
 * çevirici bir gün ayrışırdı.
 */
export function LegacyRedirect({
  to,
  rules,
}: {
  to: string;
  rules?: readonly LegacyParamRule[] | undefined;
}) {
  const location = useLocation();
  const current = new URLSearchParams(location.search);
  const migrated = rules && rules.length > 0 ? (migrateLegacyParams(current, rules) ?? current) : current;
  const search = migrated.toString();
  return (
    <Navigate
      to={{ pathname: to, search: search ? `?${search}` : "", hash: location.hash }}
      replace
    />
  );
}
